export enum PartnersType {
  septeo = 'septeo',
  orisha = 'immofacile',
}

export const partnersTypeAsString = (partnersType: PartnersType | string): string => {
  switch (partnersType) {
      case PartnersType.septeo:
          return "Modelo Office";
      case PartnersType.orisha:
          return "ImmoFacile";
      default:
          return "-";
  }
};

export const isValidPartnersType = (partnersType: PartnersType): boolean => {
  return Object.values(PartnersType).includes(partnersType);
};

/** Partner systems whose billing is handled externally (not via Stripe self-service). */
export const EXTERNALLY_BILLED_SYSTEMS: string[] = [PartnersType.septeo];

export const isExternallyBilled = (partnerSystem: string | undefined | null, idStripe?: string | null): boolean => {
  if (!EXTERNALLY_BILLED_SYSTEMS.includes(partnerSystem ?? '')) return false;
  // A Stripe customer means billing is handled internally (partner centers billed by us), so not externally billed.
  return !idStripe;
};

export default PartnersType;
